// extracted by mini-css-extract-plugin
export default {"hint-label":"index-module__hint-label___xHC50","hintLabel":"index-module__hint-label___xHC50"};